import { useLang } from "../LanguageContext";

export default function Footer() {
  const { t } = useLang();

  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="footer"
      className="bg-[#F5F0E8] border-t border-[#C8A96E]/30 py-12 md:py-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16 mb-12">
          {/* Brand */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_torre-amat-events/artifacts/5p7voheb_Logo%20Freehand.png"
              alt="Torre Amat"
              className="h-20 w-auto object-contain mb-3"
              style={{ mixBlendMode: "multiply" }}
            />
            <p
              className="text-xs uppercase tracking-[0.3em] text-[#C8A96E] mb-4"
              style={{ fontFamily: "Lato, sans-serif" }}
            >
              {t.footer.tagline}
            </p>
            <p
              className="text-xs uppercase tracking-[0.2em] text-[#1A1A18]/50"
              style={{ fontFamily: "Lato, sans-serif" }}
            >
              {t.footer.private}
            </p>
          </div>

          {/* Quick links */}
          <div>
            <p
              className="text-xs uppercase tracking-[0.3em] text-[#C8A96E] mb-5"
              style={{ fontFamily: "Lato, sans-serif" }}
            >
              —
            </p>
            <nav className="space-y-3">
              {[
                ["#espacio", t.nav?.espacio],
                ["#eventos", t.nav?.eventos],
                ["#galeria", t.nav?.galeria],
                ["#servicios", t.nav?.servicios],
                ["#contacto", t.nav?.contacto],
              ].map(([href, label]) => (
                <button
                  key={href}
                  onClick={() => scrollTo(href)}
                  className="block text-xs uppercase tracking-[0.2em] text-[#1A1A18]/60 hover:text-[#C8A96E] transition-colors"
                  style={{ fontFamily: "Lato, sans-serif" }}
                >
                  {label}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <p
              className="text-xs uppercase tracking-[0.3em] text-[#C8A96E] mb-5"
              style={{ fontFamily: "Lato, sans-serif" }}
            >
              Contact
            </p>
            <a
              href="mailto:info@torreamat.com"
              className="block text-sm text-[#1A1A18]/70 hover:text-[#C8A96E] transition-colors mb-3"
              style={{ fontFamily: "Lato, sans-serif" }}
            >
              info@torreamat.com
            </a>
            <p
              className="text-sm text-[#1A1A18]/50"
              style={{ fontFamily: "Lato, sans-serif" }}
            >
              Sarrià-Sant Gervasi
              <br />
              Barcelona
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#C8A96E]/20 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p
            className="text-xs text-[#1A1A18]/40"
            style={{ fontFamily: "Lato, sans-serif" }}
          >
            © {new Date().getFullYear()} Torre Amat · {t.footer.rights}
          </p>
          <div className="flex gap-1 text-xs text-[#1A1A18]/40" style={{ fontFamily: "Lato, sans-serif" }}>
            <span>Palacete Modernista</span>
            <span className="text-[#C8A96E] mx-1">·</span>
            <span>Sarrià, Barcelona</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
